import { createSelector } from 'reselect'
import type { MailingList, RecipientList, RecipientListId } from 'types/list'
import type { State } from 'types/redux'
/**
 * Gets all email groups from the state.
 * @param state - The Redux state
 * @returns Array of email group (recipient list) objects
 */
export const getEmailGroups = (state: State): RecipientList[] =>
  state.emailGroups.emailGroups
// mailing list summaries - id, name and sender fields, no recipients
export const getMailingLists = (state: State): MailingList[] =>
  state.emailGroups.mailingList
// ids whose individual fetch failed, so load gates can stop waiting on them
export const getFailedEmailGroupIds = (state: State): RecipientListId[] =>
  state.emailGroups.failedEmailGroupIds
// ids that 404'd, so rules pointing at them match nobody instead of blocking
export const getDeletedEmailGroupIds = (state: State): RecipientListId[] =>
  state.emailGroups.deletedEmailGroupIds
// a crawl page fetched before the delete can put a deleted list back, so campaign rules must skip it
export const getLiveEmailGroups = createSelector(
  [getEmailGroups, getDeletedEmailGroupIds],
  (emailGroups, deletedEmailGroupIds) =>
    emailGroups.filter(group => !deletedEmailGroupIds.includes(group.id)),
)
/**
 * Gets a specific email group by ID.
 * @param state - The Redux state
 * @param props - Object containing the list ID
 * @param props.listId - The email group ID to retrieve
 * @returns The email group object, or null/undefined if not found
 */
export const getEmailGroup = (
  state: State,
  {
    listId,
  }: {
    listId: RecipientListId
  },
): RecipientList | null | undefined =>
  state.emailGroups.emailGroups.find(group => group.id === listId)
